// Visar innehållet om kontot har rätt abonnemangsnivå – annars en förklaringsvy.
import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { PLAN_LABELS, usePlanTier, type PlanTier } from "@/hooks/usePlanTier";

interface PlanGateProps {
  required: PlanTier;
  title: string;
  description: string;
  bullets?: string[];
  children: React.ReactNode;
}

const PlanGate: React.FC<PlanGateProps> = ({ required, title, description, bullets = [], children }) => {
  const { hasTier, loading, tier } = usePlanTier();

  if (loading) return null;
  if (hasTier(required)) return <>{children}</>;

  return (
    <div className="container max-w-3xl mx-auto px-4 py-10">
      <Card>
        <CardHeader className="space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="secondary" className="gap-1">
              <Lock className="h-3 w-3" />
              Ingår i {PLAN_LABELS[required]}
            </Badge>
            <Badge variant="outline">Din nivå: {PLAN_LABELS[tier]}</Badge>
          </div>
          <CardTitle className="text-2xl">{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-5">
          <p className="text-muted-foreground">{description}</p>
          {bullets.length > 0 && (
            <ul className="space-y-2 text-sm">
              {bullets.map((b) => (
                <li key={b} className="flex gap-2">
                  <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}
          <div className="flex flex-wrap gap-2 pt-2">
            <Link to="/uppdrag">
              <Button variant="default">Tillbaka till mina uppdrag</Button>
            </Link>
            <Link to="/hjalp">
              <Button variant="outline">Läs mer om nivåerna</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlanGate;
